export default "__VITE_ASSET__DhFDDptO__"